import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const login = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/login",
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data)
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in Login >> ", err.message);
        return err.response
    }
}

export const getAdminProfileController = async (token) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/profile",
            headers: {
                'Authorization': `Bearer ${token || localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getAdminProfileController >> ", err.message);
        return err.response
    }
}

export const updateAdminProfileController = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/user-management/update-admin-profile",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in updateAdminProfileController >> ", err.message);
        return err.response
    }
}

export const forgot = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/forgot-password",
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data)
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in forgot >> ", err.message);
        return err.response
    }
}

export const verify = async (token) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/verify-token/${token}`,
            headers: {
                'Content-Type': 'application/json'
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in verify >> ", err.message);
        return err.response
    }
}

export const resetPassword = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/reset-password",
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data)
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in resetPassword >> ", err.message);
        return err.response
    }
}